export const getLoggerBaseURL = () => {
    const usePrimary = localStorage.getItem('usePrimaryServer') !== 'false';
    const baseURL = usePrimary
        ? process.env.REACT_APP_PRIMARY_BASE_URL
        : process.env.REACT_APP_SECONDARY_BASE_URL;
    return `${baseURL}/api/logs`;
};
